import * as React from "react";
import { forwardRef } from "react";
const SvgIcVirtualJoystick32 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { style: {
  opacity: 0.5
}, cx: 16, cy: 16, r: 16, fill: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { style: {
  opacity: 0.75
}, cx: 16, cy: 16, r: 8, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcVirtualJoystick32);
export { ForwardRef as ReactComponent };
